// extracted by mini-css-extract-plugin
export default {"basicInfo":"basic-info_basicInfo__80Xs5","clubOptions":"basic-info_clubOptions__rSko-","imgGrid":"basic-info_imgGrid__spWeN","under21Allowed":"basic-info_under21Allowed__rp0ee"};